import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip, IconButton } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import InfoIcon from '@material-ui/icons/Info';
import { isNil, omitBy } from 'lodash';
import { connect } from 'react-redux';
import { useLocation, Redirect } from 'react-router-dom';
import { compose } from 'redux';
import { INLINE_COLORS, Li, P, Span, formatISODateStringAsUSMonthDayYear, APPLICANTS_URL, } from 'shared';
import { ServiceProviderDisclosures } from 'components';
import { PersonalInfoForm } from '../../forms';
import { selectors } from '../reducer';
function ApplicantShow({ followOnOperation, handleSubmit, handleSubmitFailure, handleSubmitSuccess, personalInfo, practice, applicationEnvironment, }) {
    const { search } = useLocation();
    if (isNil(personalInfo)) {
        return (_jsx(Redirect, { to: {
                pathname: APPLICANTS_URL,
                search: search,
            } }));
    }
    const submitPersonalInfo = (formValues) => handleSubmit(formValues)
        .then((response) => handleSubmitSuccess(response))
        .catch((error) => handleSubmitFailure({ _error: error?.message ?? 'Submission failed' }, () => undefined, error));
    return (_jsx("div", { className: "applicant-personal-info", children: _jsxs("div", { className: "application-instructions", children: [_jsxs("div", { className: "info-header", children: [_jsxs(P, { variant: "title-large", bold: true, children: ["Find out now if you", ' ', _jsx(Span, { bold: true, variant: "title-large", children: "pre-qualify" }), ' ', "for our Access Loan product* without impacting your credit."] }), _jsx(P, { variant: "title-large", bold: true, children: "It's quick, easy, and secure with instant results." })] }), _jsxs("ul", { className: "info-content", children: [practice && practice.name && practice.locationId && (_jsxs(Li, { className: "info", variant: "title-large", listStyle: "disc", bold: true, children: ["You've selected practice ", _jsx("b", { children: practice.name }), "."] })), _jsxs(Li, { variant: "title-large", listStyle: "disc", bold: true, children: ["If your credit is locked or frozen, you'll need to remove the freeze before applying.", _jsx("div", { className: "tooltip-container", children: _jsx(Tooltip, { enterTouchDelay: 0, placement: "left", title: _jsx(P, { variant: "body-medium", style: {
                                                color: INLINE_COLORS.whiteBase,
                                            }, children: "If you placed a freeze on your credit file, please contact each credit reporting agency directly to remove the credit freeze before going through the apply process." }), children: _jsx(IconButton, { className: "icon-button", children: _jsx(InfoIcon, { style: { color: blue[800] } }) }) }) })] })] }), _jsx(PersonalInfoForm, { initialValues: formatInitialValues(personalInfo), followOnOperation: followOnOperation, practice: practice, handleSubmit: submitPersonalInfo, fieldsToExclude: applicationEnvironment.fieldsToExclude }), _jsx(ServiceProviderDisclosures, {})] }) }));
}
function mapStateToProps(state) {
    return {
        personalInfo: selectors.personalInfo(state),
    };
}
const mapDispatchToProps = {};
export default compose(connect(mapStateToProps, mapDispatchToProps))(ApplicantShow);
function formatInitialValues(personalInfo) {
    if (isNil(personalInfo))
        return {};
    const { firstName, lastName, street1, street2, city, state, zip, primaryPhone, alternatePhone, dateOfBirth, email, ssn, annualIncome, purchaseAmount, specialty, } = personalInfo;
    return omitBy({
        firstName,
        lastName,
        street1,
        street2,
        city,
        state,
        zip,
        primaryPhone,
        alternatePhone,
        email,
        ssn,
        specialty,
        dateOfBirth: isNil(dateOfBirth)
            ? undefined
            : formatISODateStringAsUSMonthDayYear(dateOfBirth),
        annualIncome: isNil(annualIncome) ? undefined : String(annualIncome),
        purchaseAmount: isNil(purchaseAmount)
            ? undefined
            : String(purchaseAmount),
        homeNumberCheck: !isNil(alternatePhone) && alternatePhone !== '',
    }, isNil);
}
